// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-right"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 17.5L18.5 12L13 6.5M17.25 12L4.25 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowRightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-right',
    ref,
    icon: element,
  },
));

ArrowRightIcon.displayName = 'ArrowRightIcon';

export default ArrowRightIcon;
